export default "/images/vendor/@coreui/icons/svg/flag/cif-cv.svg?f04b2a485265feca3e6e769b96c153c4";